var _rect, _rect2, _text, _rect3, _text2, _text3, _rect4, _text4, _text5, _text6, _line, _text7, _rect5, _text8, _text9, _text10, _line2, _polygon, _text11, _rect6, _text12, _text13, _text14, _rect7, _text15, _text16, _rect8, _text17, _text18, _line3, _polygon2, _line4, _polygon3, _rect9, _text19, _text20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitfigFigArchitecture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 460",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 460,
    fill: "#FFFDF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 440,
    height: 330,
    rx: 10,
    fill: "none",
    stroke: "#C9C2B2",
    strokeWidth: 1.5,
    strokeDasharray: "6 5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 92,
    fontSize: 15,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "INSIDE FIGMA")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 170,
    height: 90,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 158,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Plugin UI")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 182,
    fontSize: 13,
    fill: "#5A6B62",
    textAnchor: "middle"
  }, "React, sandboxed iframe")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 120,
    width: 170,
    height: 90,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 152,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Main thread")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 174,
    fontSize: 13,
    fill: "#5A6B62",
    textAnchor: "middle"
  }, "reads and writes Variables,")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 192,
    fontSize: 13,
    fill: "#5A6B62",
    textAnchor: "middle"
  }, "Styles, clientStorage")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 165,
    x2: 290,
    y2: 165,
    stroke: "#7C5CBF",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 152,
    fontSize: 12,
    fill: "#7C5CBF",
    textAnchor: "middle"
  }, "postMessage")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 250,
    width: 390,
    height: 100,
    rx: 8,
    fill: "#F3F0E6"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 284,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "No GitHub token ever enters the plugin.")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 308,
    fontSize: 13,
    fill: "#5A6B62"
  }, "The sandbox holds a session id only. Every GitHub call is")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 326,
    fontSize: 13,
    fill: "#5A6B62"
  }, "proxied through the server, which holds the OAuth token.")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 165,
    x2: 600,
    y2: 165,
    stroke: "#16A34A",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "600,165 590,160 590,170",
    fill: "#16A34A"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 152,
    fontSize: 12,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "HTTPS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 110,
    width: 220,
    height: 110,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 148,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "oauth.gitfig.com")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 172,
    fontSize: 13,
    fill: "#5A6B62",
    textAnchor: "middle"
  }, "Vercel functions: Device Flow,")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 190,
    fontSize: 13,
    fill: "#5A6B62",
    textAnchor: "middle"
  }, "token custody, GitHub proxy")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 70,
    width: 220,
    height: 80,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 103,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "GitHub API")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 126,
    fontSize: 13,
    fill: "#5A6B62",
    textAnchor: "middle"
  }, "contents, refs, PRs, Git Data")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 190,
    width: 220,
    height: 80,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 223,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Supabase / Postgres")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 246,
    fontSize: 13,
    fill: "#5A6B62",
    textAnchor: "middle"
  }, "file links, sync history, sessions")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 140,
    x2: 920,
    y2: 112,
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "920,112 909,111 912,120",
    fill: "#1A2F2A"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 190,
    x2: 920,
    y2: 222,
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "920,222 912,214 909,223",
    fill: "#1A2F2A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 280,
    width: 540,
    height: 70,
    rx: 8,
    fill: "#F3F0E6"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 308,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Multi-file pushes are one atomic commit")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 330,
    fontSize: 13,
    fill: "#5A6B62"
  }, "built through the Git Data API: blobs, tree, commit, ref update.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitfigFigArchitecture);
export default __webpack_public_path__ + "static/media/gitfig-fig-architecture.95c704ce36b0956261e5345b653bc8dc.svg";
export { ForwardRef as ReactComponent };